import React from 'react'

import './styles.css'
import { Button, Row, Col, Modal } from 'antd'

import { getMessage } from '../../util/IntlMessages'

const CustomModal = function (props) {
  return (
    <Modal
      bodyStyle={{ padding: 0, margin: 0 }}
      title={null}
      visible={props.visible}
      onOk={props.onOk}
      className={props.className || 'containerModal'}
      closable={props.closable}
      footer={null}
      afterClose={props.onCancel}
      onCancel={props.onCancel}
      onSubmit={props.onSubmit}
      zIndex={999}
      centered={props.centered || false}
    >
      {props.title && !props.customHeader && (
        <div>
          <div className="headerModal">
            <div className="titleModal">{props.title}</div>
          </div>
          <hr className="hr" />
        </div>
      )}
      {props.customHeader && <>{props.customHeader}</>}
      <div className="contentModal">
        {props.children}
        {props.useBottomButtons && (
          <Row type="flex" justify="start">
            <Col span={24}>
              <hr className="clearMarginBottom hr" />
              <div className="containerBottom">
                <Button className="buttonBottom" onClick={() => props.onCancel()}>
                  {getMessage(props.cancelText || 'close')}
                </Button>
                <Button className="buttonBottom" type="primary" onClick={() => props.onSubmit()}>
                  {getMessage(props.okText || 'save')}
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </Modal>
  )
}

export default CustomModal
